import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { connect } from 'react-redux'
import AuthHandlerInstance from '../Classes/AuthHandler'
import { getNotifications, UpdateNotification } from '../store/actions/masterActions'
import { LinkContainer } from 'react-router-bootstrap'
import { NavDropdown, Nav, Container } from 'react-bootstrap'
import env from '../ENV';
import formatDate from '../Classes/FormatDateTimeInIST';
import { Link } from 'react-router-dom';
//import { Link, NavLink, Route, Router } from 'react-router-dom';
const LOGIN_URL = env.LOGIN_URL;

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      select: true,
      currentPage: 1,
      posPerpage: 10,
      UserId: AuthHandlerInstance.getUserID(),
      open: false,
      selectAll: false,
      checked: [],
      opacity: "",
      multiCollapseIndex: "",
      notifications: [],
      notificationCount: 0,
    }
  }
  dataSync = async () => {
    let data = {
      UserId: this.state.UserId,
      currentPage: this.state.currentPage,
      posPerpage: this.state.posPerpage,
    }
    await this.props.getNotifications(data)
    let notificationCount = 0
    if (this.props.notifications && this.props.notifications.recordsets && this.props.notifications.recordsets.length > 0) {
      notificationCount = this.props.notifications.recordsets[1][0].totalcount
    }
    this.setState({ notifications: this.props.notifications.recordsets[0], notificationCount })
  }
  componentDidMount = async () => {
    await this.dataSync()
  }
  readNotification = async (elem) => {
    await this.props.UpdateNotification(this.state.UserId)
    await this.dataSync()
  }
  render() {
    let userPayload = AuthHandlerInstance.getUserPayLoad();
    console.log(this.props)
    return (

      <header className="toolbar">
        {/* <Navbar bg='dark' variant='dark' expand='lg' collapseOnSelect> */}
        <nav className="toolbar__navigation ">
          <div className="toggle-wrap" onClick={(e) => this.props.drawerClickHandler(e)}>
            <span className="toggle-bar"></span>
          </div>

          <div className="toolbar__logo ml-2" style={{display:"flex",position:"absolute",left:"3.5rem"}}>
            <a href="/">
              <img src="https://www.sms-group.com/typo3conf/ext/sms_frontend/Resources/Public/Packages/assets/sms-mode-dark-f9a3a56b33d848e1.svg" alt="" width="75%" />
              <span className="text-decoration-none text-white small">Leading Partner In The World Of Metals</span>
            </a>
          </div>

          {/* Notification Section start */}
          <div style={{position:"absolute",right:"19.5rem",display:'flex',maxWidth:"100%"}}>
            <FontAwesomeIcon className='position-relative' style={{ cursor: 'pointer' }} icon={'bell'} color="white" size="lg" />
            {this.state.notificationCount > 0 ? <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ top: "5px", marginLeft: "-8px", color: "white" }}>{this.state.notificationCount > 99 ? "99+" : this.state.notificationCount}</span> : null}
          </div>
          <NavDropdown className="dropdown" style={{position:"absolute",right:"14.5rem"}}>

            <div className="wrapper" >
              {this.state.notifications.map((elem, index) => (
                <div className="rows border" key={index} onClick={() => this.readNotification(elem)}>
                  <NavDropdown.Item className="dropdownItem">
                    <div>
                      {/* <Nav.Link as={Link} to="/" target="_blank" className="link" > <FontAwesomeIcon  className="cursor"  icon={'user'} color="black" size="lg" /> */}
                      <LinkContainer to={{ pathname: '/allNotifications', state: { poid: 6, itemNo: 29, po: 6, polineitemID: 29 } }}>
                        <Nav.Link className="link">
                          <div style={{ color: "black" }}>{elem.Message}</div>
                        </Nav.Link>
                      </LinkContainer>

                    </div>
                    <div className="align-time" >{elem.CreatedOn[0] ? formatDate(elem.CreatedOn[0]) : ""}</div>
                  </NavDropdown.Item>
                </div>
              ))}

              {/* Notification list end */}

              <div>
                <NavDropdown.Item className="footer">
                  <div>
                    <LinkContainer to="/allNotifications">
                      <Nav.Link className="footer-link" onClick={() => this.readNotification()}>
                        <div style={{ backgroundColor: "#007bff", borderRadius: "10px" }}>See All Notifications</div>
                      </Nav.Link>
                    </LinkContainer>
                  </div>
                </NavDropdown.Item>

              </div>
            </div>

          </NavDropdown>
          {/* Notification end */}

          <div style={{position:"absolute",right:"14.5rem"}}><FontAwesomeIcon title="User" icon={'user'} color="white" size="lg" /></div>
          <div className="navtextcolor " style={{ padding:"4px",position:"absolute",right:"6.9rem",textSizeAdjust:"auto",width:"120px",lineHeight:"1rem",fontSize:"14px" }} >{userPayload.fullName}</div>
          <div className="toolbar__logo pr-4" style={{position:"absolute",right:"3.2rem"}}>
            <a href={`\change-password`}>
              <button className="toggle-button " >
                <FontAwesomeIcon title="Change Password" icon={'cogs'} color="white" size="lg" />
              </button>
            </a>
          </div>
          <div className="toolbar__logo pr-4">
            <button className="toggle-button " >
              <a href={`${LOGIN_URL}`}>
                <FontAwesomeIcon onClick={() => {
                  localStorage.setItem("authDetails", "")
                }} title="logout" icon={'power-off'} color="white" size="lg" />
              </a>
            </button>

          </div>

        </nav>

      </header>
    )
  }
}
const mapStateToProps = (state) => ({ notifications: state.masterReducer.notifications })
export default connect(mapStateToProps, { getNotifications, UpdateNotification })(Navbar)
